import { PaymentSummaryType } from "@/services/models/Order";
import { GTMPaymentType } from "./GTMPaymentType";

export const PAYMENT_TYPE_TO_GTM_PAYMENT_TYPE_MAP: Record<PaymentSummaryType, GTMPaymentType> = {
    [PaymentSummaryType.CreditCard]: GTMPaymentType.CreditCard,
    [PaymentSummaryType.ApplePay]: GTMPaymentType.ApplePay,
    [PaymentSummaryType.Afterpay]: GTMPaymentType.Afterpay,
    [PaymentSummaryType.PayPal]: GTMPaymentType.PayPal,
    [PaymentSummaryType.GiftCard]: GTMPaymentType.GiftCard,
    [PaymentSummaryType.Unknown]: GTMPaymentType.Unknown
};
